import { State } from "app/store/types";

export const selectDebugMode = (state: State) => state.debugMode;

export const selectIsDebugModeActive = (state: State) =>
  selectDebugMode(state).isDebugModeActive;

export const selectIsDebuggable = (state: State) =>
  selectDebugMode(state).isDebuggable;
